import { Button } from '@repo/shadcn';
import { FC } from 'react';
import { z } from 'zod';

import { IwForm } from '@components/form';
import { TextField } from '@components/form/fields';
import { SectionTitle } from '@components/ui';

import { BrandSelector } from './brand-selector.component';
import { GenericSelector } from './generic-selector.component';
import { ProductNameSelector } from './product-name-selector.component';
import { StrengthSelector } from './strength-selector.component';
import { TypeSelector } from './type-selector.component';
import { UnitSelector } from './unit-selector.component';

const ProductFormSchema = z.object({
    name: z.string().min(1, 'Name is required'),
    name_id: z.string().optional(),

    brand_id: z.string().min(1, 'Brand is required'),
    brand_name: z.string().optional(),

    generic_id: z.string().min(1, 'Generic is required'),
    generic_name: z.string().optional(),

    strength_id: z.string().min(1, 'Strength is required'),
    strength_name: z.string().optional(),

    type_id: z.string().min(1, 'Type is required'),
    type_name: z.string().optional(),

    unit_id: z.string().min(1, 'Unit is required'),
    unit_name: z.string().optional(),

    alert_quantity: z.coerce.number().min(0, 'Alert Quantity is required'),

    purchase_price: z.coerce.number().min(0, 'Purchase Price is required'),
    retail_price: z.coerce.number().min(0, 'Retail Price is required'),
    wholesale_price: z.coerce.number().min(0, 'Wholesale Price is required'),

    shelf: z.string().optional(),
});

export type TProductForm = z.infer<typeof ProductFormSchema>;

type ProductFormProps = {
    initialValues: TProductForm;
    onSubmit?: (data: TProductForm) => Promise<void>;
    isLoading?: boolean;
    title?: string;
};

export const ProductForm: FC<ProductFormProps> = ({
    initialValues,
    onSubmit,
    isLoading = false,
    title = 'Product Form',
}) => {
    return (
        <div>
            <SectionTitle>{title}</SectionTitle>
            <IwForm
                schema={ProductFormSchema}
                initialValues={initialValues}
                onSubmit={onSubmit as any}
            >
                <div className={'grid grid-cols-2 gap-4'}>
                    <ProductNameSelector />
                    <BrandSelector />
                    <GenericSelector />
                    <TypeSelector />
                    <StrengthSelector />
                    <UnitSelector />

                    <TextField<TProductForm>
                        name={'purchase_price'}
                        label="Purchase Price"
                        placeholder="Enter purchase price"
                        required
                    />
                    <TextField<TProductForm>
                        name={'wholesale_price'}
                        label="Wholesale Price"
                        placeholder="Enter wholesale price"
                        required
                    />
                    <TextField<TProductForm>
                        name={'retail_price'}
                        label="Retail Price"
                        placeholder="Enter retail price"
                        required
                    />
                    <TextField<TProductForm>
                        name={'alert_quantity'}
                        label="Alert Quantity"
                        placeholder="Enter alert quantity"
                        required
                    />

                    {/* <TextField<TProductForm>
                        name={'shelf'}
                        label="Shelf"
                        placeholder="Enter shelf location"
                    /> */}

                    <div className={'col-span-2'}>
                        <Button type={'submit'} disabled={isLoading}>
                            {isLoading ? 'Saving...' : 'Save Changes'}
                        </Button>
                    </div>
                </div>
            </IwForm>
        </div>
    );
};
